import { GramPostProps } from "../../../Components/TheGramApp/TheGramAppInterfaces";

import jacquesPFP from "./EverestTheGramAssets/JacquesPFP.webp";
import jacquesPost from "./EverestTheGramAssets/JacquesPost.webp";

export const EverestTheGramContent: GramPostProps[] = [
  {
    Profile: { name: "@Jacquesblanchard", image: jacquesPFP },
    Date: "13 June 2025",
    Image: jacquesPost,
    Likes: "4.7K",
    Caption:
      "They told me if I'd left it one more day I would have lost my fingers! Occupational hazards! Thanks for all your help down the mountain buddy! 😂🤙🎬 #everest",
    Location: "",
  },
];
